module.exports = __webpack_public_path__ + "media/images/500_error-5b52ef2e.svg";